/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestEndedNotificationAction } from './FanRemixContestEndedNotificationAction';
import {
    FanRemixContestEndedNotificationActionFromJSON,
    FanRemixContestEndedNotificationActionFromJSONTyped,
    FanRemixContestEndedNotificationActionToJSON,
} from './FanRemixContestEndedNotificationAction';

/**
 * 
 * @export
 * @interface FanRemixContestEndedNotification
 */
export interface FanRemixContestEndedNotification {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndedNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndedNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof FanRemixContestEndedNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestEndedNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<FanRemixContestEndedNotificationAction>}
     * @memberof FanRemixContestEndedNotification
     */
    actions: Array<FanRemixContestEndedNotificationAction>;
}

/**
 * Check if a given object implements the FanRemixContestEndedNotification interface.
 */
export function instanceOfFanRemixContestEndedNotification(value: object): value is FanRemixContestEndedNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function FanRemixContestEndedNotificationFromJSON(json: any): FanRemixContestEndedNotification {
    return FanRemixContestEndedNotificationFromJSONTyped(json, false);
}

export function FanRemixContestEndedNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestEndedNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(FanRemixContestEndedNotificationActionFromJSON)),
    };
}

export function FanRemixContestEndedNotificationToJSON(value?: FanRemixContestEndedNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(FanRemixContestEndedNotificationActionToJSON)),
    };
}

